import {useCallback, useEffect, useRef, useState} from "react"
import {useHistory,useParams}from "react-router-dom"
import CenterService from "../../../services/CenterService"
import InstituteService from "../../../services/InstituteService"
import CampusService from "../../../services/CampusService"
import AcademicUnitService from "../../../services/AcademicUnitService"
import UserService from "../../../services/UserService"
import {Form, Input, Button, message,Row, Select,Steps,Card,Switch} from "antd"
import { useSelector } from "react-redux"
import { selectInstituteInformation } from "../../../Auth/instituteInformationReducer"
import { selectUser } from "../../../Auth/userReducer"


const {Option}= Select;
const layout={
  labelCol:{
    span:10,
  },
  wrapperCol:{
    span:20,
  },
  style:{
    maxWidth:1000,
  },
  initialValues:{
    remember: true,
  }
}

const rolForAssignamentInstitute=[
  "ANIDI - Director",
]

export default function CenterForm(){
  const institute=useSelector(selectInstituteInformation)
  const {current: instituteSession}=useRef(institute);
  const user=useSelector(selectUser)
  const {current: userSession}=useRef(user);
  const history= useHistory();
  const params= useParams();
  const [form] = Form.useForm();
  const [listCampus,setListCampus]=useState([{}]);
  const [listAcademicUnit,setListAcademicUnit]=useState([{}]);
  const [listInstitutes,setListInstitutes]=useState([]);
  const [listCoordinators,setListCoordinators]=useState([{}]);
  const [fields, setfields] = useState([]);
  const [fieldsSaves, setfieldsSaves] = useState({});
  const centerId= params.id;
  const [valueAU, setValueAU] = useState(null);
  const [current,setCurrent]=useState(0)
  const [assignedInstituteOpt,setAssignedInstituteOpt]=useState(false)
  const [assignedInstituteByRol,setAssignedInstituteByRol]=useState(false)
  const [instituteSelected,setInsitituteSelected]=useState(false)




  const verificityRol=()=>{
    rolForAssignamentInstitute.includes(user.rolName)? 
      setAssignedInstituteByRol(true):setAssignedInstituteByRol(false)
  }

  const createCenter=useCallback((center)=>{
    // let centerForm=verificationFieldUndefined(center)
      CenterService.postCenter(center)
      .then((res)=>{
        console.log(res)
        let {success,response,description}=res?.data
        if(success){
          message.success("Registro del centro exitoso");
          history.goBack();
        }
        else{
          message.error(description);
        }
      })
  },[]);
  
  const updateCenter=useCallback((updateCenter)=>{
    updateCenter={
      id:centerId,
      ...updateCenter
    }
    updateCenter=verificationFieldUndefined(updateCenter)
    // console.log(updateCenter)

    CenterService.updateCenter(updateCenter)
    .then((res)=>{
      let {success,description}=res.data;
      if(success){
        message.success("Actualizanción del centro exitoso");
        history.goBack();
      }
      else{
        message.error(description)
      }
    })
  },[])
  const getCenterById=useCallback((centerId)=>{
      CenterService.getCenterById(centerId)
        .then((res)=>{
          if(res.data?.response){
            const centerRes=res.data.response
            if (res.data?.response){
              const fields=[
                {
                  name:["name"],
                  value: centerRes.name || "",
                },
                {
                  name:["acronym"],
                  value: centerRes.acronym || "",
                },
                {
                  name:["academicUnitId"],
                  value: centerRes.academicUnitId || ""
                },
                {
                  name:["campusId"],
                  value: centerRes.campusId || ""
                },
                {
                  name:["coordinatorId"],
                  value: centerRes.coordinatorId || ""
                },
                {
                  name:["assignedInstitute"],
                  value: centerRes.assignedInstitute || ""
                },
                {
                  name:["instituteId"],
                  value: centerRes.instituteId || ""
                },

              ];
              setAssignedInstituteOpt(centerRes.assignedInstitute)
              setfields(fields);
              setValueAU(centerRes.academicUnitId)
              AcademicUnitService.getListAcademitUnitByCampus(centerRes.campusId).then((res)=>{
                setListAcademicUnit(res?.data?.response);
              })
            }
          }
        }).catch((e)=>{
          console.error(e)
        })
    },[]);


    const getAllCampus=useCallback(()=>{
      CampusService.getAllCampus().then((res)=>{
        setListCampus(res?.data?.response);
      })
    })

    const getListInstitutes=useCallback(()=>{
      InstituteService.getAllInstitutes().then((res)=>{
        if(res.data.success){
          let ListInstitutes=res?.data?.response;
          let ListInst=[]
          ListInstitutes.map((institute)=>{
            ListInst.push(
              {
                key: `L-${institute.id}`,
                value: institute.id,
                label: `${institute.acronym} - ${institute.name}`,
              }
            )
          })
            setListInstitutes(ListInst)
        }
        else{
          message.error("No se puede cargar la lista de institutos")
        }
      })
    })

    const getAllAcademicUnit=useCallback((campusId,body)=>{
      console.log("campusId",campusId,"body",body)
      setValueAU(null);
      AcademicUnitService.getListAcademitUnitByCampus(campusId).then((res)=>{
        setListAcademicUnit(res?.data?.response);
      })
      form.setFieldValue("academicUnitId",null)
      console.log("valueAU",valueAU)
    })

    const getAllcoordinator=useCallback((CenterId)=>{
      //let listCoordinators=[]
      if(centerId!== null && centerId > 0){
        UserService.getUsersByUpdateCoordinatorOfCenter(CenterId).then((res)=>{
          let {success,response}=res.data
          if(success){
            setListCoordinators(response);
          }else{
            message.error("No se pudo obtener los datos")
          }
        })
      }else{
        UserService.getUsersByCoordinatorOfCenter().then((res)=>{
          let {success, response}=res.data
          if(success){
            setListCoordinators(response);
          }else{
            message.error("No se pudo obtener los datos")
          }
        })
      }
    })
    
    useEffect(()=>{
      verificityRol()
      getCenterById(centerId);
      getAllCampus();
      getAllcoordinator(centerId);
      getListInstitutes();
    },[centerId])

    const verificationFieldUndefined=(dataForm)=>{
      Object.keys(dataForm).map(e=>{
        dataForm[e]=dataForm[e]===undefined? null: dataForm[e];
      });
      return dataForm;
    }


    const setassignedInsitituteIdByRol=()=>{
      return userSession.rolName==="Coordinador del instituto"?
        true : assignedInstituteOpt;
    }

    const onFinish= async()=>{
      try {
        let centerData=fieldsSaves
        let dataForm=form.getFieldsValue();
        const instituteID=userSession.rolName==="ANIDI - Director"? instituteSelected :instituteSession?.id;
        let institute= {
          assignedInstitute:setassignedInsitituteIdByRol(),
          uid:userSession.id,
          instituteId:instituteID,
        }
        centerData={
          ...centerData,
          ...dataForm,
          ...institute,
        }

        console.log('create center',centerData)
        if(centerId!== null && centerId > 0){
          updateCenter(centerData);
        }else{
          createCenter(centerData);
        }
        } catch (error) {
          console.log(error)
        }
      }

    const next = async()=> {
      try {
      await form.validateFields()
      let centerData=fieldsSaves
      let dataForm=form.getFieldsValue()
      console.log("centerData 1",centerData)
      console.log("dataForm 2",dataForm)
      setCurrent(current + 1);
      centerData={
        ...centerData,
        ...dataForm
      }
      setCurrent(current + 1);
      setfieldsSaves(centerData)

      } catch (error) {
        console.log(error)
      }
    };

    const prev = () => {
      setCurrent(current - 1);
    };
    const cancel=()=>{
      history.goBack();
    }
  
  const firstStep=()=>{
    return (
      <Form 
            {...layout}
            fields={fields}
            form={form}
            preserve={true}
            onFinish={next}
            >
              <Form.Item 
              name="name"
              label="Nombre del centro"
              rules={[
                {
                  required: true,
                  message: 'Ingrese un nombre para centro'
                }
              ]}
              >
                <Input/>
              </Form.Item>
              <Form.Item 
              name="acronym"
              label="Siglas del centro"
              rules={[
                {
                  required: true,
                  message: 'Ingrese las siglas del centro' 
                }
              ]}
              >
                <Input/>
              </Form.Item>
            </Form>
    )
  }

  const secondStep=()=>{
    return (
      <Form 
            {...layout}
            fields={fields}
            form={form}
            preserve={true}
            onFinish={next}
            scrollToFirstError
            >
              <Form.Item 
              name="campusId"
              label="Sede"
              rules={[
                {
                  required: true,
                  message: 'Seleccione lugar de la sede del centro' 
                }
              ]}
              >
                <Select 
                placeholder="Selecciona una sede" 
                onChange={(value,body)=>{getAllAcademicUnit(value,body)}}
                >
                {
                  Object.keys(listCampus).map((i,key)=>{
                    return <Option value={listCampus[key].id  } key={listCampus[key].id}>{listCampus[key].name}</Option>
                  })
                }
                </Select>
              </Form.Item>
              <Form.Item 
              label="Unidad academica"
              name="academicUnitId"
              rules={[
                {
                  required: true,
                  message: 'Seleccione la unidad academica a la que pertenece' 
                }
              ]}
              >
                <Select
                placeholder="Selecciona una unidad academica " 
                value={valueAU}
                onChange={(val)=>{setValueAU(val)}}
                allowClear
                >
                  {
                  Object.keys(listAcademicUnit).map((i,key)=>{
                    return <Select.Option value={listAcademicUnit[key]?.id} key={listAcademicUnit[key].id}>{listAcademicUnit[key].name}</Select.Option>
                  })
                  }
                </Select>
              </Form.Item>
              { assignedInstituteByRol &&(<Form.Item
              label="Asignar instituto"
              name="assignedInstitute"
              >
                <Switch 
                checked={assignedInstituteOpt}
                onChange={setAssignedInstituteOpt}
                >
                </Switch>
              </Form.Item>)
              }
              {assignedInstituteOpt && ( 
              <Form.Item
              name="instituteId"
              label="Instituto asignado"
              >
                <Select 
                options={listInstitutes}
                onChange={setInsitituteSelected}
                value={instituteSelected}
                ></Select>
              </Form.Item>)
              }
            </Form>
    )
  }

  const thirdStep=()=>{
    return (
      <Form 
            {...layout}
            fields={fields}
            form={form}
            preserve={true}
            scrollToFirstError
            onFinish={onFinish}
            >
              <Form.Item
            name="coordinatorId"
            label="Coordinador"
            >
              <Select 
              placeholder="Selecciona un coordinador"
              allowClear
              >
              {
                Object.keys(listCoordinators).map((i,key)=>{
                  return <Option value={listCoordinators[key].id  } key={listCoordinators[key].id}>{listCoordinators[key].firstName+" "+listCoordinators[key].lastName}</Option>
                })
              }
              </Select>
        </Form.Item>
      </Form>
    )
  }
  
  const items=[ {
    title: 'Datos generales',
    content: firstStep(),
  },
  {
    title: 'Ubicación',
    content: secondStep(),
  },
  {
    title: 'Coordinador',
    content: thirdStep(),
  },
];


    return (
    <>
    <Card style={{margin:50}}>
      <Steps
      items={items}
      current={current}
      style={{padding:20}}
      key={"StepForm"}
      >
      </Steps>

      <Card>
        {items[current].content}
      </Card>
      <Row align={"end"} style={{marginTop: 20}}>
      {current < items.length -1 && (
          <Button key={"btnNext"} type="submit" onClick={() => form.submit()}>
            Siguiente
          </Button>
        )}
        {current === items.length-1 && (
          <Button key={"btnFinsih"}type="primary" onClick={() => form.submit()}>
            Finalizar
          </Button>
        )}
        {current > 0 && (
          <Button
          key={"btnPrev"}
            style={{
              margin: '0 8px',
            }}
            onClick={() => prev()}
          >
            Anterior
          </Button>
        )}
         {current === 0 && (
          <Button
          key={"btnCancel"}
            style={{
              margin: '0 8px',
            }}
            onClick={() => cancel()}
          >
            Cancelar
          </Button>
        )}
      </Row>
    </Card>
    </>
    )

    
   /* return(
      <>
      <Row align="center">
      <Title className="titleCenter" style={{verticalAlign:"middle"}}>
          {centerId ? "Editar centro":"Crear centro"}
        </Title>
      </Row>
       <div id="ContainerForm">
          <Form 
          {...layout}
          fields={fields}
          form={form}
          preserve={false}
          onFinish={onFinish}
          scrollToFirstError
          >
            <Form.Item 
            name="name"
            label="Nombre del centro"
            rules={[
              {
                required: true,
                message: 'Ingrese un nombre para centro'
              }
            ]}
            >
              <Input/>
            </Form.Item>
            <Form.Item 
            name="acronym"
            label="Siglas del centro"
            rules={[
              {
                required: true,
                message: 'Ingrese las siglas del centro' 
              }
            ]}
            >
              <Input/>
            </Form.Item>
            <Form.Item 
            name="campusId"
            label="Sede"
            rules={[
              {
                required: true,
                message: 'Seleccione lugar de la sede del centro' 
              }
            ]}
            >
              <Select 
              placeholder="Selecciona una sede" 
              onChange={(value,body)=>{getAllAcademicUnit(value,body)}}
              >
              {
                Object.keys(listCampus).map((i,key)=>{
                  return <Option value={listCampus[key].id  } key={listCampus[key].id}>{listCampus[key].name}</Option>
                })
              }
              </Select>
            </Form.Item>
            <Form.Item 
            label="Unidad academica"
            name="academicUnitId"
            rules={[
              {
                required: true,
                message: 'Seleccione la unidad academica a la que pertenece' 
              }
            ]}
            >
              <Select
              placeholder="Selecciona una unidad academica " 
              value={valueAU}
              onChange={(val)=>{setValueAU(val)}}
              allowClear
              >
                {
                Object.keys(listAcademicUnit).map((i,key)=>{
                  return <Select.Option value={listAcademicUnit[key]?.id} key={listAcademicUnit[key].id}>{listAcademicUnit[key].name}</Select.Option>
                })
                }
              </Select>
            </Form.Item>
            <Form.Item
            name="coordinatorId"
            label="Coordinador"
            rules={[
              {
                required: true,
                message: 'Asigne a un coordinador para el centro' 
              }]}
            >
              <Select 
              placeholder="Selecciona un coordinador"
              >
              {
                Object.keys(listCoordinators).map((i,key)=>{
                  return <Option value={listCoordinators[key].id  } key={listCoordinators[key].id}>{listCoordinators[key].firstName+" "+listCoordinators[key].lastName}</Option>
                })
              }
              </Select>
            </Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              style={{
                float:"right",
                marginTop: 16,
                }}
                >
              {centerId? "Actualizar centro":"Registrar centro"}
            </Button>
          </Form>
        </div>
      </>
    )*/
}
